﻿<template>
    <div class="template-manage">
        <div class="page-header">
            <h2>通知书模板管理</h2>
            <div class="header-actions">
                <el-button type="primary" @click="showUploadDialog = true">
                    <i class="el-icon-upload"></i> 上传模板
                </el-button>
                <el-button @click="downloadDefaultTemplate">
                    <i class="el-icon-download"></i> 下载默认模板
                </el-button>
            </div>
        </div>

        <div class="variable-info">
            <el-alert title="模板变量说明" type="info" :closable="false">
                <div style="margin-top: 10px;">
                    <p><strong>可用变量：</strong></p>
                    <ul style="margin: 5px 0 0 20px; padding: 0; list-style-type: disc;">
                        <li><code>{XM}</code> - 考生姓名</li>
                        <li><code>{G_XYMC}</code> - 学院名称</li>
                        <li><code>{ZYMC}</code> - 专业名称</li>
                        <li><code>{BH}</code> - 录取号</li>
                        <li><code>{KSH}</code> - 考生号</li>
                        <li><code>{SHENG}</code> - 省份（已去除省/市/自治区等后缀）</li>
                        <li><code>{DURATION}</code> - 学制（如：三、四）</li>
                        <li><code>{NF}</code> - 年份</li>
                    </ul>
                    <p style="margin-top: 10px;"><strong>使用方法：</strong>在HTML模板中使用上述变量，系统会自动替换为对应的数据。</p>
                </div>
            </el-alert>
        </div>

        <div class="template-list">
            <el-table :data="templateList" border style="width: 100%">
                <el-table-column prop="FileName" label="模板名称" width="200">
                    <template slot-scope="scope">
                        <span>{{ scope.row.FileName }}.html</span>
                    </template>
                </el-table-column>
                <el-table-column prop="FirstUploadDate" label="首次上传时间" width="180">
                    <template slot-scope="scope">
                        <span>{{ formatDate(scope.row.FirstUploadDate) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="LastUpdateDate" label="最后修改时间" width="180">
                    <template slot-scope="scope">
                        <span>{{ formatDate(scope.row.LastUpdateDate) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="AddUserName" label="上传人" width="120"></el-table-column>
                <el-table-column prop="LastModifier" label="最后修改人" width="120"></el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button type="text" @click="editTemplate(scope.row)">
                            <i class="el-icon-edit"></i> 编辑
                        </el-button>
                        <el-button type="text" @click="deleteTemplate(scope.row)" style="color: #f56c6c">
                            <i class="el-icon-delete"></i> 删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div v-if="templateList.length === 0" class="empty-state">
                <i class="el-icon-document"></i>
                <p>暂无模板，请上传HTML模板文件</p>
            </div>
        </div>

        <el-dialog title="上传模板" :visible.sync="showUploadDialog" width="500px">
            <el-form :model="uploadForm" label-width="80px">
                <el-form-item label="文件">
                    <input 
                        type="file" 
                        ref="fileInput"
                        accept=".html" 
                        style="display: none;"
                        @change="handleFileChange" />
                    <el-button 
                        v-if="!uploadForm.file" 
                        size="small" 
                        type="primary" 
                        @click="triggerFileSelect">
                        选择文件
                    </el-button>
                    <div v-else class="selected-file">
                        <i class="el-icon-document"></i>
                        <span>{{ uploadForm.file.name }}</span>
                        <el-button size="small" type="text" @click="clearFile">移除</el-button>
                    </div>
                    <div style="margin-top: 8px; color: #909399; font-size: 12px;">只支持.html文件</div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showUploadDialog = false"><i class="el-icon-close"></i> 取消</el-button>
                <el-button type="primary" @click="submitUpload" :loading="uploading"><i class="el-icon-upload"></i> 上传</el-button>
            </div>
        </el-dialog>

        <el-dialog title="编辑模板" :visible.sync="showEditDialog" width="800px" top="5vh">
            <div class="edit-container">
                <el-form :model="editForm" label-width="80px">
                    <el-form-item label="模板名称">
                        <el-input :value="editForm.fileName + '.html'" disabled style="width: 250px"></el-input>
                    </el-form-item>
                    <el-form-item label="模板内容">
                        <el-input
                            v-model="editForm.content"
                            type="textarea"
                            :rows="20"
                            placeholder="请输入HTML内容"
                            style="width: 100%; font-family: 'Consolas', 'Monaco', 'Courier New', monospace; font-size: 12px;">
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showEditDialog = false"><i class="el-icon-close"></i> 取消</el-button>
                <el-button type="primary" @click="saveEdit" :loading="saving"><i class="el-icon-check"></i> 保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { TYBM_Env } from '../../env.js';
import { TYBM_Tools } from '../../tools.js';

export default {
    name: 'TemplateManage',
    data() {
        return {
            templateList: [],
            showUploadDialog: false,
            showEditDialog: false,
            uploading: false,
            saving: false,
            uploadForm: {
                file: null
            },
            editForm: {
                fileName: '',
                content: ''
            }
        };
    },
    methods: {
        downloadDefaultTemplate() {
            const defaultTemplate = `
<div class="notice-container">
    <img src="/Gxzs/Image/武职录取通知书空白版.jpg" class="notice-bg" />
    <div class="field-layer">
        <div class="inline-row name-row">
            <span class="text-indent-span"></span>
            <span class="text-content">{XM}&nbsp;</span>
            <span>同学：</span>
        </div>
        <div class="content-wrapper">
            <div class="content-box">
                <div class="text-row">
                    <span class="text-indent-span"></span><span>经</span>
                    <span class="text-content">  {SHENG}  </span>
                    <span>（省、市、自治区）高等学校招生委员会批准，你被录取到我校</span>
                    <span class="text-content">  {G_XYMC}  {ZYMC}  </span>
                    <span>专业学习，学制{DURATION}年。请你持本通知书于{NF}年9月11日按时到我校报到。</span>
                </div>
            </div>
            <div class="inline-row info-row">
                <span class="text-indent-span"></span>
                <span>录取号：</span><span class="inline-input">{BH}</span><span class="info-gap"></span><span>考生号：</span><span class="inline-input">{KSH}</span>
            </div>
        </div>
    </div>
</div>
            `.trim();
            
            const blob = new Blob([defaultTemplate], { type: 'text/html;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'notice_template.html';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        },
        loadTemplateList() {
            const api_name = '/Notice/Template/GetTemplateList';
            const url = TYBM_Env.GetApiUrl(api_name);
            
            TYBM_Tools.AxiosPostEx(this, api_name, url, {}, { loading: true })
                .then(response => {
                    this.templateList = response.data || [];
                })
                .catch(error => {
                    this.$message.error('加载模板列表失败：' + error.errmsg);
                });
        },
        triggerFileSelect() {
            this.$refs.fileInput.click();
        },
        handleFileChange(event) {
            const fileList = event.target.files;
            if (fileList.length > 0) {
                const file = fileList[0];
                const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
                if (ext !== '.html') {
                    this.$message.error('只支持.html文件');
                    event.target.value = '';
                    return;
                }
                this.uploadForm.file = file;
            }
        },
        clearFile() {
            this.uploadForm.file = null;
            this.$refs.fileInput.value = '';
        },
        submitUpload() {
            if (!this.uploadForm.file) {
                this.$message.error('请选择文件');
                return;
            }
            
            this.uploading = true;
            const api_name = '/Notice/Template/UploadTemplate';
            const url = TYBM_Env.GetApiUrl(api_name);
            
            const data = { file: this.uploadForm.file };
            
            TYBM_Tools.AxiosUploadFile(this, api_name, url, data, { loading_msg: '正在上传', has_progress: true })
                .then(response => {
                    this.$message.success(response.errmsg);
                    this.showUploadDialog = false;
                    this.uploadForm.file = null;
                    this.$refs.fileInput.value = '';
                    this.loadTemplateList();
                })
                .catch(error => {
                    this.$message.error(error.errmsg);
                })
                .finally(() => {
                    this.uploading = false;
                });
        },
        editTemplate(row) {
            this.editForm.fileName = row.FileName;
            this.editForm.content = '';
            
            // 单独获取模板内容
            const api_name = '/Notice/Template/GetTemplateContent';
            const url = TYBM_Env.GetApiUrl(api_name) + '?fileName=' + encodeURIComponent(row.FileName);
            
            // 使用XMLHttpRequest直接GET请求，避免AxiosPostEx的参数处理问题
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.onload = () => {
                if (xhr.status === 200) {
                    try {
                        const result = JSON.parse(xhr.responseText);
                        if (result.code === 'ok') {
                            this.editForm.content = result.data.Content || result.data.L_Content || '';
                            this.showEditDialog = true;
                        } else {
                            this.$message.error(result.errmsg || '加载模板内容失败');
                        }
                    } catch {
                        this.$message.error('解析模板内容失败');
                    }
                } else {
                    this.$message.error('加载模板内容失败，HTTP状态码：' + xhr.status);
                }
            };
            xhr.onerror = () => {
                this.$message.error('加载模板内容失败，网络错误');
            };
            xhr.send();
        },
        saveEdit() {
            if (!this.editForm.content) {
                this.$message.error('内容不能为空');
                return;
            }
            
            this.saving = true;
            const api_name = '/Notice/Template/UpdateTemplate';
            const url = TYBM_Env.GetApiUrl(api_name);
            
            const formData = new FormData();
            formData.append('fileName', this.editForm.fileName);
            // Base64编码HTML内容，避免安全检测拦截
            const encodedContent = btoa(unescape(encodeURIComponent(this.editForm.content)));
            formData.append('content', encodedContent);
            
            const xhr = new XMLHttpRequest();
            xhr.open('POST', url, true);
            xhr.onload = () => {
                if (xhr.status === 200) {
                    try {
                        const result = JSON.parse(xhr.responseText);
                        if (result.code === 'ok') {
                            this.$message.success(result.errmsg);
                            this.showEditDialog = false;
                            this.loadTemplateList();
                        } else {
                            this.$message.error(result.errmsg || '保存失败');
                        }
                    } catch (e) {
                        this.$message.error('解析响应失败：' + xhr.responseText);
                    }
                } else {
                    this.$message.error('保存失败，HTTP状态码：' + xhr.status + '，响应：' + xhr.responseText);
                }
                this.saving = false;
            };
            xhr.onerror = () => {
                this.$message.error('保存失败，网络错误');
                this.saving = false;
            };
            xhr.send(formData);
        },
        deleteTemplate(row) {
            this.$confirm('确定要删除模板 "' + row.FileName + '.html" 吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const api_name = '/Notice/Template/DeleteTemplate';
                const url = TYBM_Env.GetApiUrl(api_name) + '?fileName=' + encodeURIComponent(row.FileName);
                
                TYBM_Tools.AxiosPostEx(this, api_name, url, {}, { loading: true })
                    .then(response => {
                        this.$message.success(response.errmsg);
                        this.loadTemplateList();
                    })
                    .catch(error => {
                        this.$message.error(error.errmsg);
                    });
            }).catch(() => {});
        },
        formatDate(dateStr) {
            if (!dateStr) return '';
            try {
                const date = new Date(dateStr);
                return date.toLocaleString('zh-CN', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit'
                });
            } catch {
                return dateStr;
            }
        }
    },
    mounted() {
        this.loadTemplateList();
    }
};
</script>

<style scoped>
.template-manage {
    padding: 20px;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.page-header h2 {
    margin: 0;
    font-size: 20px;
    color: #303133;
}

.header-actions {
    display: flex;
    gap: 10px;
}

.template-list {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    color: #909399;
}

.empty-state i {
    font-size: 48px;
    margin-bottom: 16px;
    color: #c0c4cc;
}

.empty-state p {
    margin: 0;
    font-size: 14px;
}

.edit-container {
    max-height: 60vh;
    overflow-y: auto;
}

.el-textarea__inner {
    resize: vertical;
}

.selected-file {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: #f5f7fa;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
}

.selected-file i {
    color: #409EFF;
}

.selected-file span {
    flex: 1;
    font-size: 13px;
    color: #606266;
}
</style>